import {
  CustomerSearchFormStep,
  FORM_STEP_CONTAINER_MIN_WIDTH,
  FORM_STEP_CONTAINER_WIDTH,
  TYPOGRAPHY_STYLES,
} from '../../constants';

// COMPONENTS
import { Spinner } from '@tackle-io/platform-ui';
import { Typography } from 'ui';
import { Box } from 'vendor/material';
import BackLink from '../../../components/BackLink/BackLink';

export default function CustomerSearchLoading({
  setFormStep,
}: {
  setFormStep: (step: CustomerSearchFormStep) => void;
}) {
  return (
    <Box
      minWidth={FORM_STEP_CONTAINER_MIN_WIDTH}
      width={FORM_STEP_CONTAINER_WIDTH}
    >
      <BackLink onClick={() => setFormStep(CustomerSearchFormStep.SEARCH)} />
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        mt={4}
      >
        <Spinner type="ellipsis" />
        <Typography style={{ ...TYPOGRAPHY_STYLES, fontSize: '14px' }}>
          Searching accounts...
        </Typography>
      </Box>
    </Box>
  );
}
